import React from 'react';

// Price-tag outline: pointed at the start edge (mirrored in Arabic), cut with
// clip-path so the shape costs no stylesheet bytes (main.css budget).
const SHAPE = {
  ltr: 'polygon(7px 0,100% 0,100% 100%,7px 100%,0 50%)',
  rtl: 'polygon(0 0,calc(100% - 7px) 0,100% 50%,calc(100% - 7px) 100%,0 100%)',
};

/**
 * The sale ticket: a brand-red notched tag with "−30%" (a real saving from
 * the API prices only; the caller decides when there is one). Screen
 * readers hear `label` ("30% off") instead of the glyphs.
 */
const SaleTicket = ({ pct, label, rtl = false, large = false, testId = 'sale-badge' }) => (
  <span
    className={`anum-sale-badge relative inline-flex items-center whitespace-nowrap bg-badge-sale font-extrabold text-white ${
      large ? 'py-1 text-[14px] leading-4' : 'py-0.5 text-[12px] leading-4'
    }`}
    style={{
      clipPath: SHAPE[rtl ? 'rtl' : 'ltr'],
      paddingInlineStart: large ? 16 : 13,
      paddingInlineEnd: large ? 10 : 7,
      borderRadius: rtl ? '4px 0 0 4px' : '0 4px 4px 0',
    }}
    data-testid={testId}
  >
    {/* the punched hole of a swing tag */}
    <span aria-hidden="true" className="absolute top-1/2 rounded-full bg-paper" style={{ width: 4, height: 4, marginTop: -2, insetInlineStart: 6 }} />
    <bdi dir="ltr" aria-hidden="true">−{pct}%</bdi>
    <span className="sr-only">{label}</span>
  </span>
);

export default SaleTicket;
